import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import spreadsheetValidations from './spreadsheetValidations'

const validateRows = rows => {
  const invalidCRFs = []
  for (const crf of rows) {
    const crfCopy = [...crf]
    const value = crfCopy[5].value
    if (value !== 'CV #') {
      if (value !== '') {
        if (isNaN(value)) {
          invalidCRFs.push(crfCopy)
        } else {
          if (value.length !== 9) {
            invalidCRFs.push(crfCopy)
          } else {
            if (value.charAt(0) !== '1') {
              invalidCRFs.push(crfCopy)
            }
          }
        }
      }
    }
  }
  return invalidCRFs
}
export class CheckPreparationModal extends Component {
  state = {
    departmentLists: [],
    selectedDepartment: '',
    department: ['']
  }

  render () {
    // This is the validation if date is exceeded (Leap year is included)
    let invalid = this.props.grid

    const invalidData = invalid.filter(crf => {
      return (
        spreadsheetValidations.numbers(crf[5].value, crf[6].value) ||
        spreadsheetValidations.dates(crf[6].value, crf[5].value)
      )
    })
    const gridWithInput = this.props.grid.filter(
      crf => crf[5].value.trim() !== '' && crf[5].value.trim() !== 'CV #'
    )

      
    return (
      <div id='modalBody' className='modalBody'>
        <div className='modalContainer'>
          <div className='modalbg'>
            <div id='modalContentDashboard'>
              <div className='updatingChecksContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <h4 className='returnHeader'>Nothing To Update</h4>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <h4>Update to Check Available</h4>
                        <h5 className='returnHeader'>
                          Are you sure you want to proceed? Please confirm.
                        </h5>
                      </>
                    ) : (
                      <h4 style={textRed}>Error</h4>
                    )}
                  </>
                )}

                {invalidData.map(crf => (
                  <div className='updatingChecksContent'>
                    <div className='inProcessCrfDetail'>
                      <span>CRF#:{crf[1].value}</span>
                    </div>
                    <div className='inProcessCrfDetail'>
                      <span style={textRed}>
                        CV #:
                        {spreadsheetValidations.numbers(crf[5].value)
                          ? crf[5].value.trim() === ''
                            ? 'Empty'
                            : 'invalid'
                          : crf[5].value.trim()}
                      </span>
                    </div>
                    <div className='inProcessCrfDetail'>
                      <span
                        style={
                          spreadsheetValidations.dates(crf[6].value)
                            ? textRed
                            : null
                        }
                      >
                        CV Date:
                        {crf[6].value === ''
                          ? 'Empty'
                          : spreadsheetValidations.dates(crf[6].value)
                          ? 'Invalid'
                          : crf[6].value.trim()}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              {gridWithInput.length === 0 && invalidData.length === 0 ? null : (
                <>
                  {invalidData.length === 0 &&
                  gridWithInput.length !== 0 ? null : (
                    <div className='returnHeader'>
                      <h6>Date must be valid and in MM/DD/YYYY format</h6>
                    </div>
                  )}
                </>
              )}

              <div className='updateToCheckPrepareButtonContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <button
                      className='updateToCheckPrepareCloseButton'
                      onClick={this.props.closeModal}
                    >
                      Ok
                    </button>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <button
                          className='updateToCheckPrepareCloseButton'
                          onClick={this.props.closeModal}
                        >
                          Cancel
                        </button>
                        <button
                          className='updateToCheckPrepareUpdateButton'
                          onClick={this.props.handleUpdateToCheckPrepared}
                        >
                          Confirm
                        </button>
                      </>
                    ) : (
                      <button
                        className='updateToCheckPrepareCloseButton'
                        onClick={this.props.closeModal}
                      >
                        Close
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const textRed = {
  color: 'red'
}

export default CheckPreparationModal
